import api from '../store/apiClient';

/** @param {object} opts */
export async function getProductReviews(productSlugOrMongoId, opts = {}) {
  const res = await api.get(
    `/products/${encodeURIComponent(String(productSlugOrMongoId || '').trim())}/reviews`,
    { params: opts },
  );
  const body = res.data ?? {};
  const reviews = body.data;
  const summary = body.summary ?? null;
  return { reviews: Array.isArray(reviews) ? reviews : [], summary };
}

export async function postProductReview(productSlugOrMongoId, body) {
  const { data } = await api.post(
    `/products/${encodeURIComponent(String(productSlugOrMongoId || '').trim())}/reviews`,
    body,
  );
  return data?.data ?? data;
}

export async function getReviewsOverview(limitOrOpts = 20) {
  const limit =
    typeof limitOrOpts === 'object' && limitOrOpts !== null
      ? Math.min(80, Math.max(1, parseInt(String(limitOrOpts.limit ?? 20), 10) || 20))
      : Math.min(80, Math.max(1, parseInt(String(limitOrOpts), 10) || 20));
  const res = await api.get('/reviews/overview', { params: { limit } });
  const body = res.data ?? {};
  const payload = body.data ?? {};
  return {
    summary: payload.summary ?? { average: 0, count: 0 },
    reviews: Array.isArray(payload.reviews) ? payload.reviews : [],
  };
}
